module.exports = __webpack_public_path__ + "img/set2.07bfd8fa.png";